import { render, staticRenderFns } from "./TheoPlayer.vue?vue&type=template&id=aeb4e5b0&scoped=true&"
import script from "./TheoPlayer.vue?vue&type=script&lang=js&"
export * from "./TheoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./TheoPlayer.vue?vue&type=style&index=0&id=aeb4e5b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb4e5b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aeb4e5b0')) {
      api.createRecord('aeb4e5b0', component.options)
    } else {
      api.reload('aeb4e5b0', component.options)
    }
    module.hot.accept("./TheoPlayer.vue?vue&type=template&id=aeb4e5b0&scoped=true&", function () {
      api.rerender('aeb4e5b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mix/TheoPlayer.vue"
export default component.exports